<template>
  <div class="main">
    <div v-if="REGISTER===false">
      <div class="logo">
        <img src="../assets/images/logo3.png" alt="">
      </div>
      <div>
        <van-cell-group>
          <van-field placeholder="请填写身份证号码" v-model="ID_CARD" />
          <van-field placeholder="请填写手机号" v-model="PHONE_NUM">
            <van-button slot="button" size="small" type="primary" @click="sendVerifyCode" :disabled="sendVerifyDisabled"
              v-text="verifyText"></van-button>
          </van-field>
          <van-field placeholder="请填写验证码" v-model="CODE" />
        </van-cell-group>
      </div>
      <div class="regist">
        <router-link to="/verifyingCode">
          <a>新用户注册</a>
        </router-link>
      </div>
      <div class="btndiv">
        <button type="button" class="login" @click="login">登 录</button>
        <!-- <button type="button" class="login" @click="register">注册</button> -->
      </div>
    </div>
    <div v-else>
      <register @LOGIN="finish"></register>
    </div>
  </div>
</template>

<script>
  import api from "@/fetch/api";
  import register from '@/pages/personRegister';
  import {
    Dialog,
    Toast
  } from 'vant';
  import {
    mapActions
  } from 'vuex';
  import md5 from 'js-md5';
  import { restore } from '../fetch/twocode';
  export default {
    data() {
      return {
        ID_CARD: '',
        PHONE_NUM: '',
        CODE: '',
        REAL_CODE: '',
        REGISTER: false,
        DATA: {
          currentCustomerName: '',
          currentCustomerId: '',
          token: ''
        },
        sendVerifyDisabled: false,
        verifyText: '发送验证码',
        verifySecond: 60,
        timer: null
      }
    },
    components: {
      register
    },
    methods: {
      ...mapActions({
        setUserInfo: "setUserInfo",
        setBasicData: "setBasicData"
      }),
      finish(val) {
        if (val == true) {
          this.REGISTER = false;
          this.$emit('finish', true);
          // var data = JSON.parse(sessionStorage.getItem('AYUserLogin'));
          // this.ID_CARD = data.ID_CARD;
          // this.PHONE_NUM = data.PHONE_NUM;
        } else {
          this.REGISTER = false;
        }
      },
      sendVerifyCode() {
        if (this.sendVerifyDisabled === false) {
          if (!this.ID_CARD) {
            Toast.fail('请填写身份证号码');
            return false;
          }
          if (!this.PHONE_NUM) {
            Toast.fail('请填写手机号');
            return false;
          }
          this.sendVerifyDisabled = true;
          let params = {
            ID_CARD: this.ID_CARD,
            PHONE_NUM: this.PHONE_NUM
          };
          api.getVerifyingCode(params).then(re => {
            console.log(re);
            if (re.result == true) {
	        //  var code = restore(1218281500);
          //                  alert(code)
              //let data = re.data;
              //console.log(data);
              //this.REAL_CODE = data.code;
              //this.DATA.currentCustomerName = data.currentCustomerName;
              //this.DATA.currentCustomerId = data.currentCustomerId;
            } else {
              Toast.fail(re.msg);
            }
          });
          this.verifyText = '60s';
          let that = this;
          this.timer = setInterval(function () {
            if (that.verifySecond == 1) {
              clearInterval(that.timer);
              that.verifyText = '重新发送';
              that.verifySecond = 60;
              that.sendVerifyDisabled = false;
            } else {
              that.verifySecond--;
              that.verifyText = that.verifySecond + 's';
            }
          }, 1000);
        }
      },
      login() {
        if (this.ID_CARD == '') {
          Toast.fail('请填写身份证号码！');
          return false;
        }
        if (this.PHONE_NUM == '') {
          Toast.fail('请填写手机号！');
          return false;
        }
        if (this.CODE == '') {
          Toast.fail('请填写验证码！');
          return false;
        }
        /**if (md5(this.CODE) == this.REAL_CODE) {
            this.setUserInfo(this.DATA.currentCustomerId,"123456");
            this.setBasicData();
            Toast.success('登录成功！');
            setTimeout(() => {
                this.$emit('finish', true);
            }, 1000);
        } else {
            Toast.fail('您输入的验证码不正确！');
        }**/
        console.log(this.CODE);
        api.getToken(this.ID_CARD, this.CODE).then(re => {
          console.log(re);
          if (re.result == true) {
            let test = re.data;
            //this.DATA.currentCustomerName = test.currentCustomerName;
            this.DATA.currentCustomerId = test.currentCustomerId;
            this.DATA.token = test.token;
            var idAndToken = {
              id: this.DATA.currentCustomerId,
              token: this.DATA.token
            }
            this.setUserInfo(idAndToken);
            var url = location.href;
            console.log(url);
            if (url.indexOf("?") != -1) {
              var str = url.substr(7);
              var strs = str.split("&state=");
              console.log("code等于" + strs[1]);
            }
            this.setBasicData();
            setTimeout(() => {
              this.$emit('finish', true);
            }, 1000);
          } else {
            Toast.fail('您输入的验证码不正确！');
          }

        });
      },
      register() {
        this.REGISTER = true;
      },
      getRequest() {
        var url = location.search;
        if (url.indexOf("?") != -1) {
          var str = url.substr(7);
          strs = str.split("&state=");
          return (strs[1]);
        }
      }
    },
    created() {
      window.scroll(0, 0);
    },
    mounted() {
      clearInterval(this.timer)
    },
    distroyed: function () {
      clearInterval(this.timer)
    }

  }

</script>

<style scoped lang="less">
  .logo {
    text-align: center;
    padding: 2em 0;
    background: #fff;

    img {
      width: 30%;
    }
  }

  .regist {
    padding: 1em;
    background: #fff;
    text-align: right;

    a {
      font-size: 1em;
      text-decoration: underline;
    }
  }

  .btndiv {
    text-align: center; // position: absolute;
    // bottom: 6rem;
    width: 100%;
    word-spacing: 1rem;
    padding: 2em 0;
    background: #fff;
  }

  .login {
    color: #ffffff;
    background-color: #74b13f;
    box-sizing: border-box;
    border: 1px solid #74b13f;
    border-radius: 5px;
    box-shadow: none;
    font-size: 1rem; // width: 6rem;
    width: 80%;
    height: 3em;
    text-align: center; // margin: 5rem 0.5rem;
  }

  .van-button {
    border-color: #74b13f;
    color: #74b13f;
    background-color: #fff;
    border-radius: 5px;
  }

  .register {
    color: #ffffff;
    background-color: #74b13f;
    box-sizing: border-box;
    border: 1px solid #74b13f;
    border-radius: 5px;
    box-shadow: none;
    font-size: 1rem;
    width: 6rem;
    height: 2.4rem;
    text-align: center;
    margin: 5rem 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/login.vue